import { useState, useEffect } from 'react';
import { Menu, X, Phone, Download, TrendingUp, Home, CreditCard, PieChart, Shield, ArrowUpDown, Building, TrendingDown } from 'lucide-react';

export const Header = () => {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 20);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const navLinks = [
    { href: '#investice', label: 'Investice', icon: TrendingUp },
    { href: '#hypoteka', label: 'Hypotéka', icon: Home },
    { href: '#uver', label: 'Úvěr', icon: CreditCard },
    { href: '#budget', label: '50/30/20', icon: PieChart },
    { href: '#pojisteni', label: 'Pojištění', icon: Shield },
    { href: '#prijmy-vydaje', label: 'Příjmy/Výdaje', icon: ArrowUpDown },
    { href: '#duchod', label: 'Důchod', icon: Building },
    { href: '#inflace', label: 'Inflace', icon: TrendingDown },
  ];

  return (
    <header
      data-testid="main-header"
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        isScrolled
          ? 'bg-navy/95 backdrop-blur-lg shadow-lg'
          : 'bg-transparent'
      }`}
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex items-center justify-between h-16">
          {/* Logo */}
          <a
            href="/"
            data-testid="logo-link"
            className="flex items-center gap-2 group"
          >
            <span className="font-serif text-xl font-bold">
              <span className="text-white">Pan Čung</span>
              <span className="text-gold ml-1">Radí</span>
            </span>
          </a>

          {/* Desktop Navigation - Calculator shortcuts */}
          <nav className="hidden lg:flex items-center gap-1">
            {navLinks.map((link) => {
              const Icon = link.icon;
              return (
                <a
                  key={link.label}
                  href={link.href}
                  className="flex items-center gap-1.5 px-3 py-2 text-gray-400 hover:text-white transition-colors text-sm"
                >
                  <Icon className="w-4 h-4" />
                  <span>{link.label}</span>
                </a>
              );
            })}
          </nav>

          {/* Mobile Menu Button */}
          <button
            data-testid="mobile-menu-btn"
            onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
            className="lg:hidden p-2 text-white hover:text-gold transition-colors"
          >
            {isMobileMenuOpen ? <X className="w-6 h-6" /> : <Menu className="w-6 h-6" />}
          </button>
        </div>
      </div>

      {/* Mobile Menu */}
      {isMobileMenuOpen && (
        <div
          data-testid="mobile-menu"
          className="lg:hidden bg-navy-light border-t border-navy-lighter"
        >
          <div className="px-4 py-4 space-y-2">
            {navLinks.map((link) => {
              const Icon = link.icon;
              return (
                <a
                  key={link.label}
                  href={link.href}
                  className="flex items-center gap-3 py-2 text-gray-400 hover:text-white transition-colors"
                  onClick={() => setIsMobileMenuOpen(false)}
                >
                  <Icon className="w-5 h-5" />
                  <span>{link.label}</span>
                </a>
              );
            })}
            <div className="pt-4 space-y-3 border-t border-navy-lighter mt-4">
              <a
                href="https://pancungradi.simplybook.it/v2/#book"
                target="_blank"
                rel="noopener noreferrer"
                className="flex items-center justify-center gap-2 w-full btn-gold"
              >
                <Phone className="w-4 h-4" />
                Rezervovat hovor ZDARMA
              </a>
            </div>
          </div>
        </div>
      )}
    </header>
  );
};
